export { schema, component } from './hover_image_card';
